import SelectorView from 'app/views/selector_view';

export default SelectorView.extend({
  initialize(options) {
    this.dependentSelection = options.dependentSelection;
    this.listenTo(this.dependentSelection, 'change', this.render);
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    const selector = this.getCurrentSelectionModel();
    return {
      choices: selector.choices,
      currentChoice: this.model.get('currentChoice'),
    };
  },

  getCurrentSelectionModel() {
    const dynamicKey = this.dependentSelection.get('currentChoice').option;
    return this.model.dropdowns[dynamicKey];
  },
});



// WEBPACK FOOTER //
// ./app/views/dynamic_selector_view.js